"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.initialState = {
    notificationCount: 0,
    notificationsSeen: false,
    toastMessage: '',
    filledToastMessage: '',
    notificationMessage: {
        level: 'success',
        message: '',
    },
};
var reducers = (_a = {},
    _a[constants_1.SET_NOTIFICATION_COUNT] = function (state, action) { return (__assign(__assign({}, state), { notificationCount: action.payload })); },
    _a[constants_1.SET_NOTIFICATIONS_SEEN] = function (state, action) { return (__assign(__assign({}, state), { notificationsSeen: action.payload })); },
    _a[constants_1.TOAST_MESSAGE] = function (state, action) { return (__assign(__assign({}, state), { toastMessage: action.payload })); },
    _a[constants_1.FILLED_TOAST_MESSAGE] = function (state, action) { return (__assign(__assign({}, state), { filledToastMessage: action.payload })); },
    _a[constants_1.SET_NOTIFICATION_MESSAGE] = function (state, action) {
        state.notificationMessage = action.payload;
    },
    _a);
exports.default = toolkit_1.createReducer(exports.initialState, reducers);
//# sourceMappingURL=reducer.js.map